module.exports = __webpack_public_path__ + "static/media/d2b.84db5aec.png";